import {sendGtagEvent} from "../middleware/middleware-error-handler";

export function getTranslation(key, dynamicInputs = []){
	// debugger
	const translation = staticString(key);
	if(dynamicInputs.length === 0 && translation.indexOf("{}") === -1){
		return translation
	} else {
		return dynamicString(translation, dynamicInputs)
	}

}

function staticString(key) {
	if(window.translation && window.translation[key] !== undefined){
		return window.translation[key]
	} else {
		if(process.env.NODE_ENV === "development"){
			throw Error(`Key: ${key} is not present in english translation`)
		} else {
			sendGtagEvent("Missing translation", new Error(`key: ${key}`))
		}
		return ""
	}
}

function dynamicString(staticString, dynamicInputs){
	const staticParts = staticString.split("{}");
	throwIfNumberOfInputsIncorrect(staticParts, dynamicInputs);

	return staticParts.reduce((acc, part, index) => {
		if(dynamicInputs[index] !== undefined){
			return acc + part + dynamicInputs[index]
		} else {
			return acc + part
		}
	}, "")
}

function throwIfNumberOfInputsIncorrect(staticParts, dynamicInputs) {
	if(staticParts.length -1 !== dynamicInputs.length){
		throw Error(`Number of arguments is wrong ${staticParts} ${dynamicInputs}`)
	}
}
